export function getUserLocale() {
  const primaryLanguage =
    navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : null;
  const browserLanguage = navigator.language || null;
  
  const rawLocale = primaryLanguage && primaryLanguage !== 'unknown'
    ? primaryLanguage
    : browserLanguage && browserLanguage !== 'unknown'
      ? browserLanguage
      : null;

  if (!rawLocale) return null;

  // "-" 또는 "_" 이전 부분만 반환 
  const [lang] = rawLocale.split(/[-_]/);
  return lang;
};